<script setup lang="ts">
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'
  import CellQC from '@qicgroupdoha/qic-connect-ds/components/CellQC'
  import { CARD_TITLE_TEST_ID, CARD_CONTENT_ITEM_TEST_ID } from './InformationCardQC.constants'

  interface Props {
    title?: string
    options?: {
      title: string
      content: string
    }[]
  }

  withDefaults(defineProps<Props>(), {
    title: 'Information Card QC',
    options: () => [],
  })
</script>

<template>
  <WrapperQC direction="column" padding="var(--spacing-6)" class="info-card">
    <WrapperQC
      direction="row"
      gap="var(--spacing-4)"
      :padding="{ bottom: options.length > 0 ? 'var(--spacing-5)' : 0 }"
      class="info-card__header"
    >
      <div class="info-card__header-icon">
        <IconQC name="plane-2" color="var(--colorIcnSrfPrimary)" size="sm" />
      </div>
      <h1 class="info-card__header-title heading-5" :data-test="CARD_TITLE_TEST_ID">
        {{ title }}
      </h1>
    </WrapperQC>
    <WrapperQC
      v-if="options.length > 0"
      direction="column"
      gap="var(--spacing-2-5)"
      :padding="{ top: 'var(--spacing-5)' }"
      class="info-card__content"
    >
      <CellQC
        v-for="(item, idx) in options"
        :key="idx"
        :title="item.title"
        :value="item.content"
        :padding-block="0"
        class="info-card__content-item"
        title-color="var(--colorTxtSrfTertiary)"
        :data-test="CARD_CONTENT_ITEM_TEST_ID"
      />
    </WrapperQC>
  </WrapperQC>
</template>

<style lang="scss" scoped>
  @use '@qicgroupdoha/qic-connect-ds/scss/typography';

  .info-card {
    border-radius: var(--radius-6);
    border: 1px solid var(--colorBrdrSrfSecondary);
  }

  .info-card__header {
    align-items: center;
  }

  .info-card__content {
    border-top: 1px solid var(--colorBrdrSrfSecondary);
  }

  .info-card__header-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;

    /* qic-connect-ignore-next-line */
    border-radius: 50%;
    background-color: var(--colorBgSrfTertiary);
    flex-shrink: 0;
  }

  .info-card__content-item {
    :deep(.ds-cell__inner) {
      gap: var(--spacing-3);
      align-items: initial;

      .ds-cell__title {
        @include typography.text-small-regular;
      }

      .ds-cell__value {
        @include typography.text-small-medium;
        text-align: end;
      }
    }
  }
</style>
